module.exports = __webpack_public_path__ + "img/Setting.5ec8e7a1.svg";